export const AUTH_CONSTANTS = {
  TOKEN_STORAGE_ITEM: 'authToken',
};
